import { FilterState } from "../interfaces/FilterState";

type UpdateUrlOptions = { replace?: boolean };

export const updateUrlParams = (
  filters: FilterState,
  options: UpdateUrlOptions = { replace: true },
) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const unique = value.filter((v, i, arr) => v && arr.indexOf(v) === i);
      unique.forEach((v) => params.append(key, v));
    } else if (value instanceof Date) {
      params.set(key, value.toISOString());
    } else if (value) {
      params.set(key, String(value));
    }
  });

  const qs = params.toString();
  const { pathname, search, hash } = window.location;

  const newUrl = qs
    ? `${pathname}?${qs}${hash || ""}`
    : `${pathname}${hash || ""}`;

  if ((qs || "") === (search.startsWith("?") ? search.slice(1) : search))
    return;

  const fn = options.replace ? "replaceState" : "pushState";
  window.history[fn]({}, "", newUrl);
};
